"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
        onCreate: function() {
          GState.bind(this, [
              "user"
            ]);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Dashboard/Learner/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Header_Learner_template = require("../../../components/Header-Learner.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Header_Learner_tag = marko_loadTag(Header_Learner_template),
    MyMeetings_template = require("./components/MyMeetings.marko"),
    MyMeetings_tag = marko_loadTag(MyMeetings_template),
    MyCourses_template = require("./components/MyCourses.marko"),
    MyCourses_tag = marko_loadTag(MyCourses_template),
    MyPrograms_template = require("./components/MyPrograms.marko"),
    MyPrograms_tag = marko_loadTag(MyPrograms_template),
    Wrapper_template = require("../../../../components/Wrapper/index.marko"),
    Wrapper_tag = marko_loadTag(Wrapper_template),
    marko_attrs0 = {
        "class": "content-body pb-4"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("1616b8"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_tag({
      class: "pl-5 pr-3",
      scroll: true,
      renderBody: function(out) {
        Header_Learner_tag({
            intro: "Good day",
            concern: state.user.first_name + "!",
            assessment: {
                icon: "bx bxs-smile",
                subject: "How do you feel today?"
              },
            ranking: {}
          }, out, __component, "1");

        out.be("div", marko_attrs0, "2", component);

        out.be("section", null, "3", component);

        MyMeetings_tag({}, out, __component, "4");

        MyCourses_tag({}, out, __component, "5");

        out.n(marko_node0, component);

        MyPrograms_tag({}, out, __component, "7");

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
